import { IconAnchorButton, SplitButton } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useSidebarData } from "../api/sidebarService";
import { ApplicationForSidebarResource } from "../types/applicationForSidebar";

interface Props {
	linkTo: (carFleet: ApplicationForSidebarResource) => string;
}

export const CarFleetTestDrivesLinks: FC<Props> = ({ linkTo }) => {
	const { sidebarData } = useSidebarData();
	const { t } = useTranslation();
	const carFleets = sidebarData?.applications?.carFleets ?? [];

	if (carFleets.length === 0) {
		return null;
	}

	if (carFleets.length === 1) {
		return <IconAnchorButton href={linkTo(carFleets[0])} title={t("Test Drives")} iconSrc="/car.svg" size="small" />;
	}

	const options: any[] = carFleets.map((carFleet) => {
		return {
			title: t("Test Drives in {{name}}", { name: carFleet.subdomain }),
			onClick: () => window.open(linkTo(carFleet), "_blank"),
		};
	});

	return <SplitButton options={options} size="small" />;
};
